export class AppConstant {
    public static AUTH_TOKEN_NAME = 'hrd-authenticationToken';
}